import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 9FF7DF3F-D575-433B-9C9A-69C58363C186
 * name alert
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alert.svg
 * tags
 * - Alert / Error 
 */
export const AlertIcon = createSvgIcon(<><path d="M13 14H11V9H13M13 18H11V16H13M1 21H23L12 2L1 21Z" /></>, 'AlertIcon');
export default AlertIcon